import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { useDashboardAPI } from '../../../hooks';
import { notificationsConfig } from '../../../config/constants';
export const useWeatherQuery = (params) => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        queryKey: ['weather', params],
        queryFn: () => api.weather.getWeather(params),
        enabled: !!params.latitude && !!params.longitude,
        onError: () => {
            dispatch(error({
                translationKey: 'widget:widget:cant_load_weather',
                ...notificationsConfig.defaultConf,
            }));
        },
    });
};
//# sourceMappingURL=useWeatherQuery.js.map